<div class="row">
  <!-- Product Selection -->
  <div class="col-md-8">
    <h5 class="mb-3">Sélection des articles</h5>
    <div class="row g-2">
      <div class="col-6 col-sm-4 col-md-3" *ngFor="let article of itemsArticle">
        <div class="card h-100 text-center p-2" [class.selected]="isInCart(article)">
          <div class="card-body p-2">
            <img
              [src]="article.image_url ? article.image_url : defaultImage"
              [alt]="article.libelle"
              width="70"
              height="70"
              class="mb-2 rounded"
            />
            <h6 class="card-title mb-1">{{ article.libelle }}</h6>
            <p class="mb-1"><strong>{{ article.prix_vente | number:'1.0-0' }} FCFA</strong></p>

            <!-- Quantity Controls -->
            <div class="d-flex justify-content-center align-items-center mt-2">
              <button 
                type="button" 
                class="btn btn-sm btn-outline-danger me-2" 
                (click)="decreaseQuantity(article)"
                [disabled]="getQuantity(article) === 0">
                −
              </button>
              <span>{{ getQuantity(article) }}</span>
              <button 
                type="button" 
                class="btn btn-sm btn-outline-success ms-2" 
                (click)="increaseQuantity(article)">
                +
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Transaction Summary -->
  <div class="col-md-4">
    <h5 class="mb-3">Résumé de la commande</h5>
    
    <div *ngIf="cartItems.length === 0" class="empty-cart">
      <p class="text-muted text-center py-4">Aucun article sélectionné</p>
    </div>

    <ul class="list-group mb-3" *ngIf="cartItems.length > 0" style="max-height: 300px;overflow: auto;">
      <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let item of cartItems" >
        <span>{{ item.libelle }} x{{ item.quantity }}</span>
        <span>{{ (item.prix_vente * item.quantity) | number:'1.0-0' }} FCFA</span>
      </li>
    </ul>
    
    <div class="d-flex justify-content-between mb-3" *ngIf="cartItems.length > 0">
      <strong>Total:</strong>
      <strong>{{ getTotal() | number:'1.0-0' }} FCFA</strong>
    </div>
  </div>
</div>